import { render, staticRenderFns } from "./fanqiQueRen.vue?vue&type=template&id=6a5f85a0&"
import script from "./fanqiQueRen.vue?vue&type=script&lang=js&"
export * from "./fanqiQueRen.vue?vue&type=script&lang=js&"
import style0 from "./fanqiQueRen.vue?vue&type=style&index=0&id=6a5f85a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports